<template>
    <div class="sharing-actions">

        <el-popover
            placement="bottom-start"
            :width="showCopiedToClipboard ? 155 : 350"
            :title="showCopiedToClipboard ? null : 'Route teilen'"
            :visible-arrow="showCopiedToClipboard"
            :popper-class="`smr-popper ${ showCopiedToClipboard ? 'smr-popper--offset-left-small smr-popper--show-arrow' : 'smr-popper--offset-left' }`"
            trigger="click"
            v-model="popperOpen"
            :disabled="nativeSharing && mobile"
            @show="popperShowHandler"
            @hide="popperHideHandler"
        >
            <SharingActions @copiedChange="copiedChangeHandler" @closePopup="closePopupHandler" />
            <div slot="reference">
                <slot />
            </div>
        </el-popover>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SharingActions from '@/components/SharingActions.vue'

export default {
    components: {
        SharingActions
    },
    data() {
        return {
            nativeSharing: navigator.share !== undefined,
            popperOpen: false,
            showCopiedToClipboard: false,
        }
    },
    computed: {
        ...mapGetters(['mobile']),
    },
    methods: {
        popperShowHandler() {
            if(this.mobile) {
                this.$store.commit('setDim', true)
            }
        },
        popperHideHandler() {
            if(this.mobile) {
                this.$store.commit('setDim', false)
            }
        },
        closePopupHandler() {
            this.popperOpen = false
        },
        copiedChangeHandler(value) {
            this.showCopiedToClipboard = value
        }
    }
}
</script>